import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="top_nav_1"> 苌弘青云欢迎您 </div>
        <div className="top_nav_2"> 玉经磨琢多成器， 剑拔沉埋更倚天 </div>
        <div className="SubSite-Link-Group1">
          <div className="SubSite-Link-Group2">
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Excel_Logo.png" alt=""/>
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Excel
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/CAD_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                CAD
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Scratch_Logo.png" alt="" />
              <a
                className="External-Link"
                href="/files/Scratch_3.29.1.rar"
                rel="noopener noreferrer"
              >
                下载Scratch3.29.1
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/ModuRapid_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                模立得
              </a>
            </div>
          </div>
          <div className="SubSite-Link-Group2">
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Rhino_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rhino/Grasshopper
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Blender_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Blender/SU
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Grasshopper_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                CAD/Rhino二次开发
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Sketchup_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.modurapid.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                SU/Blender二次开发
              </a>
            </div>
          </div>
          <div className="SubSite-Link-Group2">
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Python_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://www.python.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                Python
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/Cplusplus_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://cplusplus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                C++
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/CSharp_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://cplusplus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                C#
              </a>
            </div>
            <div className="SubSite-Link">
              <img className="SubSite_Logo" src="/images/VisualLisp_Logo.png" alt="" />
              <a
                className="External-Link"
                href="https://cplusplus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visual Lisp
              </a>
            </div>
          </div>
        </div>
        <div className="bottom_nav">
          <div>视频号/抖音/小红书/B站： 苌弘青云Lab， 微信：CLSR_A01， QQ：44502559</div>
          <div>
            <a
              className="Beian-link"
              href="https://beian.miit.gov.cn"
              target="_blank"
              rel="noopener noreferrer"
            >
              蜀ICP备17022048号-5
            </a>
            &nbsp;&nbsp;
            <img src="/images/beianIcon.png" width="16px" height="17px" alt=""/>
            <a className="Beian-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=51102502000173" rel="noreferrer noreferrer" target="_blank">川公网安备51102502000173号</a>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
